import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BarChartOptions } from '../../../models/bar-chart-options';
import { ChartData } from '../../../models/chart-data.model';

@Component({
    selector: 'lex-horizontal-bar-chart',
    templateUrl: './horizontal-bar-chart.component.html',
    styleUrls: ['./horizontal-bar-chart.component.scss'],
    standalone: false
})
export class HorizontalBarChartComponent implements OnInit {

  @Input() data: ChartData[];
  @Input() options: BarChartOptions;
	// eslint-disable-next-line @angular-eslint/no-output-native
  @Output() select = new EventEmitter<ChartData>();

  ngOnInit(): void {
    if (!this.options) {
      // Default options.
      this.options = new BarChartOptions();
    }
  }

  onSelect(event): void {
    this.select.emit(event);
  }
}
